import React, { useState, useEffect } from 'react';
import { post, put } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from '../icons';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../components/Breadcrumb';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import { useSelector, useDispatch } from 'react-redux';
import { FetchSubCategories } from '../../store/reducers/cake_sub_category_reducer';
import CakeCategory from '../../components/CakeCategory';

const SubCategories = () => {
  const formFields = {
    name: '',
    parentId: '',
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [formDetails, setFormDetails] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [query, setQuery] = useState('');

  const subCategoryList = useSelector((state) => state?.cake_sub_categories?.subCategories);
  const totalRecords = useSelector((state) => state?.cake_sub_categories?.totalRecords);

  const dispatch = useDispatch();

  const getCategories = () => {
    dispatch(FetchSubCategories(`&query=${query}&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`));
  };

  const handleShow = () => {
    setShowConfirmModel(true);
    setFormDetails(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    const category = subCategoryList.find((cat) => {
      return cat.id === +id;
    });
    if (category) {
      setFormDetails(category);
      setShowConfirmModel(true);
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let _formDetails = { ...formDetails, [name]: value };
    setFormDetails(_formDetails);
  };

  const handleFileChange = (e) => {
    e.preventDefault();
    setFormDetails({ ...formDetails, image: e.target.files[0] });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    for (const key in formDetails) {
      if (key === 'image') continue;
      formData.append(key, formDetails[key]);
    }
    if (formDetails.image !== null) formData.append('image', formDetails['image']);

    if ('id' in formDetails) {
      await put(formData, '/cake/categories/' + formDetails.id, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setShowConfirmModel(false);
          getCategories();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
        });
    } else {
      await post(formData, '/cake/categories', false)
        .then((res) => {
          toast.success('Category added successfully');
          setShowConfirmModel(false);
          getCategories();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
        });
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getCategories();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getCategories();
  }, [dispatch, currentPage]);

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Cake Managment' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Sub-Category' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Sub Categories | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Sub Category
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Parent Category</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {subCategoryList?.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>
                          <img
                            alt={item?.name}
                            src={`${process.env.REACT_APP_BASE_URL}/${item?.image}`}
                            style={{ maxWidth: '103px', maxHeight: '103px' }}
                          />
                        </td>
                        <td>{item?.name}</td>
                        <td>{item?.ParentCategory?.name}</td>
                        <td className="actions">
                          <span className="edit-icon" onClick={(e) => handleEdit(e, item?.id)}>
                            <EditIcon style={{ color: 'teal' }} />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {showConfirmModel && (
        <Modal size="md" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>{'id' in formDetails ? 'Edit Sub Category' : 'Add Sub Category'}</Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
          </Modal.Header>
          <Modal.Body>
            <Form autoComplete="off">
              <Row>
                <Col xs={12}>
                  <FloatingLabel label="Name" className="mb-3">
                    <Form.Control
                      className="input"
                      name="name"
                      onChange={handleChange}
                      value={formDetails.name}
                      type="text"
                      placeholder="Name"
                      required
                      autoComplete="false"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={12}>
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    className="input mb-3"
                    name="image"
                    accept="image/jpeg, image/png, image/jpg"
                    onChange={handleFileChange}
                    type="file"
                    required
                    autoComplete="false"
                  />
                </Col>
                <Col xs={12}>
                  <FloatingLabel label="Parent Category" className="mb-3">
                    <CakeCategory required category={formDetails.parentId} onChange={handleChange} label={'Category'} name={'parentId'} />
                  </FloatingLabel>
                </Col>
              </Row>
              <div className="container text-center">
                <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                  {'id' in formDetails ? 'Update' : 'Add'}
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default SubCategories;
